<template>
    <b-col cols="12" class="d-flex entradas-disponibles align-items-center justify-content-center">
        <h5 :class="pt ? pt : (pb ? pb : '')">
            <i class="fa fa-clock"></i>
            {{ time !== $t('carrito.tiempo_agotado') ? ($t('carrito.entradas_disponibles') + ': ' + time) : $t('carrito.tiempo_agotado') }}
        </h5>
    </b-col>
</template>

<script>
    export default {
        props: ['secondsLeft', 'pt', 'pb'],
        data() {
            return {
                time: null,
                interval: null,         
            }
        },
        computed: {
            avisoCarritoMostrado() {
                return this.$store.getters.getAvisoOnline || this.$store.getters.getAvisoTaquilla;
            }
        },
        mounted(){
            this.startCountdown(this.secondsLeft);
        },
        watch: {
            secondsLeft(newVal) {
                if (newVal !== null && newVal > 0) {
                    this.startCountdown(newVal);
                } 
            }
        },
        methods: {
            startCountdown(initialSeconds) {

                let remainingTime = initialSeconds;

                const minutes = Math.floor(remainingTime / 60);
                const seconds = remainingTime % 60;

                this.time = `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;

                if (remainingTime > 300 && this.avisoCarritoMostrado) {
                    this.$store.dispatch('AVISO_CARRITO', false);
                } else if (remainingTime <= 300 && !this.avisoCarritoMostrado) {
                    this.$modal.show('carrito-aviso');
                    this.$store.dispatch('AVISO_CARRITO', true);
                }
            }

        }
    }
</script>

<style scoped>
    .entradas-disponibles {
        height: 50px;
        background-color: #032550;
        color: white;
    }
</style>